import { BannerItem, LinkLocationType } from "../services/bannerServices";

export type BannerEventType = "banner_click" | "banner_shown";

export const gaClickBanner = (position: LinkLocationType, item: BannerItem) => {
  gaBanner("banner_click", position, item);
};

export const gaShownBanner = (position: LinkLocationType, item: BannerItem) => {
  gaBanner("banner_shown", position, item);
};

export const gaBanner = (
  eventType: BannerEventType,
  position: LinkLocationType,
  item: BannerItem
) => {
  if (window.gtag) {
    window.gtag("event", eventType, {
      event_category: "banner",
      event_label: item.linkUrl,
      value: item.linkUrl,
      banner_position: position,
      type: item.type,
      tag_id: item.tagId,
    });
  }
};
